import {
  HEIGHT_METRIC,
  WEIGHT_METRIC,
  TEMPERATURE_METRIC,
  GLUCOSE_METRIC,
} from '../../../constants';

export const getHeightOptions = formatMessage => {
  return [
    {
      value: HEIGHT_METRIC.FEET_INCHES,
      label: formatMessage({
        id: 'profile.section.unitsSettings.height.metric.feet_and_inches',
      }),
    },
    {
      value: HEIGHT_METRIC.METERS,
      label: formatMessage({
        id: 'profile.section.unitsSettings.height.metric.meters',
      }),
    },
  ];
};

export const getWeightOptions = formatMessage => {
  return [
    {
      value: WEIGHT_METRIC.POUNDS,
      label: formatMessage({
        id: 'profile.section.unitsSettings.weight.metric.pounds',
      }),
    },
    {
      value: WEIGHT_METRIC.KG,
      label: formatMessage({
        id: 'profile.section.unitsSettings.weight.metric.kilograms',
      }),
    },
  ];
};

export const getTemperatureOptions = formatMessage => {
  return [
    {
      value: TEMPERATURE_METRIC.FAHRENHEIT,
      label: formatMessage({
        id: 'profile.section.unitsSettings.temperature.metric.fahrenheit',
      }),
    },
    {
      value: TEMPERATURE_METRIC.CELSIUS,
      label: formatMessage({
        id: 'profile.section.unitsSettings.temperature.metric.celsius',
      }),
    },
  ];
};

export const getGlucoseOptions = formatMessage => {
  return [
    {
      value: GLUCOSE_METRIC.MMOL_PER_LITER,
      label: formatMessage({
        id: 'profile.section.unitsSettings.glucose.metric.mmol/L',
      }),
    },
    {
      value: GLUCOSE_METRIC.MG_PER_DECILITER,
      label: formatMessage({
        id: 'profile.section.unitsSettings.glucose.metric.mg/dL',
      }),
    },
  ];
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/UnitsSettings/constants.js